import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  addItemToCart,
  changeItemAmount
} from "../redux/winesSlice";

import "./PageShopProducts.css";

function PageShopProducts() {

  const [searchParams] = useSearchParams();

  const siteId = searchParams.get("site_id");
  const catId = searchParams.get("cat_id");
  const shopName = searchParams.get("shop_name");
  const categoryName = searchParams.get("category_name");

  const dispatch = useDispatch();

  const itemsInCart = useSelector(
    state => state.wines.cart
  );

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [shopConflict, setShopConflict] = useState(null);
  const [pendingItem, setPendingItem] = useState(null);

  const [searchText, setSearchText] = useState("");


  /* =====================================================
     STOCK LIMIT MESSAGE
  ===================================================== */

  const showStockLimit = () => {
    alert("No more items available");
  };


  /* =====================================================
     ADD ITEM / SHOP CONFLICT
  ===================================================== */

  const handleAddToCart = (newItem) => {

    if (itemsInCart.length === 0) {

      dispatch(addItemToCart(newItem));

      return;
    }


    const existingShop =
      itemsInCart[0]?.item?.shop;

    const newShop =
      newItem.item.shop;


    if (existingShop !== newShop) {

      setShopConflict(existingShop);
      setPendingItem(newItem);

      return;
    }


    dispatch(addItemToCart(newItem));
  };


  /* =====================================================
     REPLACE CART
  ===================================================== */

  const confirmReplaceCart = () => {

    itemsInCart.forEach(item => {

      dispatch(
        changeItemAmount({
          currentItemId: item.item.id,
          currentAmount: 0
        })
      );

    });


    if (pendingItem) {

      dispatch(
        addItemToCart(pendingItem)
      );

    }


    setPendingItem(null);
    setShopConflict(null);
  };


  /* =====================================================
     FETCH PRODUCTS
  ===================================================== */

  useEffect(() => {

    async function fetchProducts() {

      try {

        setLoading(true);


        const response = await fetch(
          `https://gitstool.in/liquor/shop_app/addmore_product.php?site_id=${siteId}`,
          {
            method: "POST",

            headers: {
              "Content-Type": "application/json"
            },

            body: JSON.stringify({
              site_id: siteId
            })
          }
        );


        const data = await response.json();


        console.log(
          "Products from API:",
          data
        );


        if (!Array.isArray(data)) {

          setProducts([]);

          return;
        }


        const filtered = data.filter(product => {

          const sameShop =
            String(product.site_id) ===
            String(siteId);


          const sameCategory =
            String(product.cat_id) ===
            String(catId);


          return (
            sameShop &&
            sameCategory
          );

        });


        console.log(
          "After filter:",
          filtered
        );


        setProducts(

          filtered.map(product => ({

            ...product,

            id:
              `${product.bm_id}_${product.site_id}`

          }))

        );


      } catch (err) {

        console.log(err);

        setProducts([]);

      } finally {

        setLoading(false);

      }

    }


    fetchProducts();

  }, [siteId, catId]);


  /* =====================================================
     LOADING
  ===================================================== */

  if (loading) {

    return (
      <div className="page-shop-products-loading">
        Loading Products...
      </div>
    );

  }


  /* =====================================================
     SEARCH
  ===================================================== */

  const filteredProducts =
    products.filter(product => {

      if (!searchText.trim()) {
        return true;
      }


      return product.brand_nm
        ?.toLowerCase()
        .includes(
          searchText.toLowerCase()
        );

    });


  console.log(
    "Products:",
    products
  );

  console.log(
    "Filtered Products:",
    filteredProducts
  );

  console.log(
    "siteId:",
    siteId
  );

  console.log(
    "catId:",
    catId
  );


  /* =====================================================
     RENDER
  ===================================================== */

  return (

    <div className="page-shop-products">


      {/* =================================================
          HEADER
      ================================================= */}

      <div className="shop-products-header">


        {/* SHOP NAME */}

        <h2 className="shop-products-shop-name">
          {shopName}
        </h2>


        {/* CATEGORY */}

        <h2 className="shop-products-title">
          {categoryName}
        </h2>


        {/* SEARCH */}

        <input
          type="text"
          className="shop-products-search"
          placeholder="Search products..."
          value={searchText}
          onChange={(e) =>
            setSearchText(e.target.value)
          }
        />

      </div>


      {/* =================================================
          PRODUCT LIST
      ================================================= */}

      <div className="shop-products-list">


        {filteredProducts.length === 0 ? (

          <div className="no-products">
            No Products Found
          </div>

        ) : (

          filteredProducts.map(product => {


            /* =============================================
               THREE SIZES
            ============================================= */

            const sizes = [

              {
                key: "Q",
                label: `${product.sizeq}ML`,
                rate: product.rateq,
                stock: Number(product.stk_q)
              },

              {
                key: "P",
                label: `${product.sizep}ML`,
                rate: product.ratep,
                stock: Number(product.stk_p)
              },

              {
                key: "N",
                label: `${product.sizen}ML`,
                rate: product.raten,
                stock: Number(product.stk_n)
              }

            ];


            return (

              <div
                key={product.id}
                className="shop-product-card"
              >


                {/* =========================================
                    PRODUCT NAME
                ========================================= */}

                <div className="shop-product-name">
                  {product.brand_nm}
                </div>


                {/* =========================================
                    PRODUCT BODY
                ========================================= */}

                <div className="shop-product-body">


                  {/* PRODUCT IMAGE */}

                  <div className="shop-product-image">

                    <img
                      src={`https://gitstool.in/liquor/shop_app/${product.thumb}`}
                      alt={product.brand_nm}
                    />

                  </div>


                  {/* =======================================
                      PRODUCT DETAILS
                  ======================================= */}

                  <div className="shop-product-details">


                    {/* =====================================
                        SIZE HEADER
                    ===================================== */}

                    <div className="size-header-row">


                      {sizes.map(size => (

                        <div
                          key={size.key}
                          className="size-column"
                        >

                          <div className="size-label">
                            {size.label}
                          </div>

                        </div>

                      ))}


                    </div>


                    {/* =====================================
                        STOCK ROW
                    ===================================== */}

                    <div className="stock-row">


                      <div className="row-title">
                        In Stock:
                      </div>


                      {sizes.map(size => (

                        <div
                          key={size.key}
                          className="row-value"
                        >
                          {size.stock}
                        </div>

                      ))}


                    </div>


                    {/* =====================================
                        PRICE ROW
                    ===================================== */}

                    <div className="price-row">


                      <div className="row-title">
                        MRP:
                      </div>


                      {sizes.map(size => (

                        <div
                          key={size.key}
                          className="row-value"
                        >
                          ₹{size.rate}
                        </div>

                      ))}


                    </div>


                    {/* =====================================
                        SIZE-SPECIFIC CART BUTTONS
                    ===================================== */}

                    <div className="add-buttons-row">


                      {sizes.map(size => {


                        /* =================================
                           UNIQUE CART ID FOR EACH SIZE

                           Example:

                           1453_Q
                           1453_P
                           1453_N
                        ================================= */

                        const sizeId =
                          `${product.id}_${size.key}`;


                        /* =================================
                           FIND THIS SIZE IN CART
                        ================================= */

                        const sizeCartItem =
                          itemsInCart.find(
                            item =>
                              item.item.id ===
                              sizeId
                          );


                        /* =================================
                           CURRENT QUANTITY
                        ================================= */

                        const sizeAmount =
                          sizeCartItem
                            ? sizeCartItem.amount
                            : 0;


                        /* =================================
                           STOCK
                        ================================= */

                        const stock =
                          Number(size.stock);


                        /* =================================
                           OUT OF STOCK
                        ================================= */

                        if (stock === 0) {

                          return (

                            <button
                              key={sizeId}
                              className="size-add-btn disabled"
                              disabled
                            >
                              Out of Stock
                            </button>

                          );

                        }


                        /* =================================
                           ADD + STATE
                        ================================= */

                        if (sizeAmount === 0) {

                          return (

                            <button
                              key={sizeId}
                              className="size-add-btn"
                              onClick={() => {


                                /* =========================
                                   CREATE CART ITEM
                                ========================= */

                                const newItem = {

                                  item: {

                                    id: sizeId,

                                    site_id:
                                      product.site_id,

                                    cat_id:
                                      product.cat_id,

                                    bm_id:
                                      product.bm_id,

                                    shop:
                                      product.shop,

                                    group:
                                      product.group,

                                    shopAdd:
                                      product.shopAdd,

                                    brand_nm:
                                      product.brand_nm,

                                    cat_name:
                                      product.cat_name,

                                    thumb:
                                      product.thumb,


                                    selectedRate:
                                      size.rate,

                                    selectedStock:
                                      size.stock,

                                    selectedSize:
                                      size.label

                                  },

                                  amount: 1

                                };


                                /* =========================
                                   ADD TO CART
                                ========================= */

                                handleAddToCart(
                                  newItem
                                );

                              }}
                            >
                              Add +
                            </button>

                          );

                        }


                        /* =================================
                           QUANTITY STATE

                           - 1 +
                        ================================= */

                        return (

                          <div
                            key={sizeId}
                            className="size-add-btn qty-controls"
                          >


                            {/* =============================
                                MINUS
                            ============================= */}

                            <span
                              onClick={() => {

                                dispatch(

                                  changeItemAmount({

                                    currentItemId:
                                      sizeId,

                                    currentAmount:
                                      sizeAmount - 1

                                  })

                                );

                              }}
                            >
                              -
                            </span>


                            {/* =============================
                                QUANTITY
                            ============================= */}

                            <span className="qty">
                              {sizeAmount}
                            </span>


                            {/* =============================
                                PLUS
                            ============================= */}

                            <span
                              onClick={() => {


                                /* =========================
                                   STOCK LIMIT
                                ========================= */

                                if (
                                  sizeAmount >=
                                  stock
                                ) {

                                  showStockLimit();

                                  return;
                                }


                                /* =========================
                                   INCREASE QUANTITY
                                ========================= */

                                dispatch(

                                  changeItemAmount({

                                    currentItemId:
                                      sizeId,

                                    currentAmount:
                                      sizeAmount + 1

                                  })

                                );

                              }}
                            >
                              +
                            </span>


                          </div>

                        );

                      })}


                    </div>


                  </div>


                </div>


              </div>

            );

          })

        )}


      </div>


      {/* =================================================
          CART CONFLICT POPUP
      ================================================= */}

      {shopConflict && (

        <div className="cart-conflict-overlay">


          <div className="cart-conflict-box">


            <h3>
              Replace Cart?
            </h3>


            <p>
              Your cart contains products from
              <br />

              <b>
                {shopConflict}
              </b>

            </p>


            <p>
              Remove them and add products from
              another shop?
            </p>


            <div className="conflict-buttons">


              <button
                onClick={() => {

                  setShopConflict(null);
                  setPendingItem(null);

                }}
              >
                Cancel
              </button>


              <button
                onClick={
                  confirmReplaceCart
                }
              >
                Remove & Add
              </button>


            </div>


          </div>


        </div>

      )}


    </div>

  );

}
export default PageShopProducts;